import vars from "../vars";

$(document).ready(function() {

	var bodyNode = document.getElementsByTagName('body')[0];

	function openFilters() {
		vars.$asideFilter.removeClass('hide');
		$(vars.textFilterSpan).addClass('open');
		$(vars.textFilterSpan).text("Скрыть фильтры");
		vars.$btnFilter.addClass('hide');
		vars.$btnFilterFilled.removeClass('hide');

		if ($(window).width() < 1024) {
			bodyNode.classList.add('fixedPosition');
		}
	}

	function closeFilters() {
		vars.$asideFilter.addClass('hide');
		$(vars.textFilterSpan).removeClass('open');
		$(vars.textFilterSpan).text("Раскрыть фильтры");
		vars.$btnFilter.removeClass('hide');
		vars.$btnFilterFilled.addClass('hide');
	}

	$('.js-text-filter span').on('click', (e) => {
		if (vars.textFilterSpan.classList.contains('open')) {
			closeFilters();
		} else {
			openFilters();
		}
	});

	vars.$asideBtnApply.click(function() {
		closeFilters();
		bodyNode.classList.remove('fixedPosition');
	});

	function closeOpenFilters() {
		if ($(window).width() < 1024) {
			closeFilters();
		} else {
			openFilters();
		}
	}

	closeOpenFilters();
	
	var w=$(window).width();
		$(window).resize(function() {
			var new_w=$(window).width();
			if(new_w!=w) {
				closeOpenFilters();
				bodyNode.classList.remove('fixedPosition');
				w=new_w;
			}
		});
});







// WEBPACK FOOTER //
// ./src/js/general/aside-filter.js